/**
 * The brain registry (PRD #793).
 *
 * One entry per role, keyed by brain id. An archetype names a brain the way it
 * names an ability: by stable id, resolved here, guarded by the archetype test.
 */

import { meleePursuer } from './meleePursuer';
import { rangedKiter } from './rangedKiter';
import { telegraphedCaster } from './telegraphedCaster';
import { BRAIN_IDS, type Brain, type BrainId } from './types';

export const brains: ReadonlyMap<BrainId, Brain> = new Map(
  [meleePursuer, rangedKiter, telegraphedCaster].map((brain) => [brain.id, brain]),
);

/** Look up a brain. An unknown id is null rather than a throw, like the catalogs. */
export function brain(id: string): Brain | null {
  return brains.get(id as BrainId) ?? null;
}

export { BRAIN_IDS };
export { meleePursuer, rangedKiter, telegraphedCaster };
export {
  activateMemory,
  currentTarget,
  DETECTION_RADIUS_TILES,
  directionBetween,
  isDetectable,
  MEMORY_TICKS,
  pointToward,
  rememberTarget,
} from './perception';
export { MELEE_APPROACH_RADIUS_TILES, MELEE_APPROACH_SLOTS } from './meleePursuer';
export { RANGED_KITER_BAND } from './rangedKiter';
export { TELEGRAPHED_CASTER_BAND } from './telegraphedCaster';
export { createBrainMemory } from './types';
export type {
  Brain,
  BrainDecision,
  BrainId,
  BrainIntent,
  BrainMemory,
  BrainMove,
  BrainPerception,
  BrainPoint,
  BrainRng,
  PerceivedAbility,
  PerceivedAlly,
  PerceivedTarget,
} from './types';
